import React from 'react';
import Button from './Button';
import LinkButton from './LinkButton';

export default function HeroSection() {
  return (
    <section className="flex flex-col items-center justify-center px-4 sm:px-8 py-8 w-full">
      <div className="flex flex-col gap-4 items-start max-w-[1080px] w-full">
        <h1 className="font-trispace type-h1 w-full max-w-[600px] text-black">
          High Quality.<br />
          High Output. Software Engineering.
        </h1>
        <p className="font-trispace type-body1 text-black max-w-[600px] w-full">
          We build software by channelling years of domain expertise into artificial intelligence
          tools — delivering end-to-end products and experiences that were once only possible at scale.
        </p>
        <div className="flex items-center gap-4 max-w-[600px] w-full">
          <a href="#services"><Button>Explore What We Do</Button></a>
          <LinkButton href="#work">
            See Our Work
          </LinkButton>
    
        </div>
      </div>
    </section>
  );
}
